// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_887","index":"styles_index__ae9kI"};